import React from "react";
import {
  Container,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const UserTerms = () => {
  const userTermsEN = `
<div class="saku-terms-user">
  <style>
    .saku-terms-user { --fg:#1f2937; --muted:#4b5563; --accent:#0ea5e9; font-family: system-ui,-apple-system,Segoe UI,Roboto,Inter,Arial,sans-serif; line-height: 1.6; color: var(--fg); }
    .saku-terms-user header { margin: 0 auto 24px; }
    .saku-terms-user main {  margin: 0 auto; }
    .saku-terms-user h1 { line-height: 1.25; margin: 0 0 8px; font-size: 2rem; font-weight: bold; }
    .saku-terms-user h2 { margin-top: 28px; font-size: 1.25rem; font-weight: bold; }
    .saku-terms-user p, .saku-terms-partner li { color: var(--fg); font-size: 1rem; }
    .saku-terms-user ul { padding-left: 20px; list-style: disc; }
    .saku-terms-user .meta { color: var(--muted); font-size: 0.95rem; }
    .saku-terms-user .card { background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; }
    .saku-terms-user a { color: var(--accent); }
    .saku-terms-user footer { margin: 36px auto 0; color: var(--muted); font-size: 0.9rem; }
  </style>

  <header>
    <h1>SAKU Terms of Use (Users)</h1>
    <p class="meta">Last updated: October 5, 2025</p>
  </header>

  <main class="card" role="main">
    <p>
      By downloading, installing, and/or using the SAKU Application, You agree that You have read,
      understood and accepted and agreed to these Terms and Conditions (“Terms of Use”).
    </p>

    <p>
      These Terms of Use constitute a legal agreement between You and SAKU (including affiliate) and
      apply to Your visit to and use of Our website at <a href="https://saku.my">https://saku.my</a> or
      other sites which We developed officially to support the Service ecosystem.
    </p>

    <p><strong>PLEASE REVIEW OUR TERMS OF USE AND PRIVACY POLICY CAREFULLY BEFORE DOWNLOADING SAKU APPLICATION OR USING OUR SERVICE FOR THE FIRST TIME.</strong></p>

    <p>
      The Services available to You on the SAKU Application are so diverse that We can include or enforce
      additional Terms of Use for the purpose of certain Services, in which the additional terms are part of
      Our Services which are bound and inherent to these Terms of Use.
    </p>

    <p>
      We reserve the right to modify, vary and change the Terms of Use or Privacy Policy relating to the Services
      at any time as it deems fit so that You are required from time to time read Our Terms of Use and Privacy Policy
      in the SAKU Application or Our website. These Terms of Use apply to You nor for Your use of the Service by or
      through Your account wherever you may be, whether in the states and federal territories of Malaysia or in any other countries.
    </p>

    <p><em>FOR THE AVOIDANCE OF DOUBT, WE ARE A SOFTWARE AS A SERVICE (SAAS) COMPANY WHICH PROVIDES PLATFORM FOR EACH SERVICES WE PROVIDE AND NOT A PUBLISHER OF ELECTRONIC MONEY.</em></p>

    <h2>1. DEFINITION</h2>
    <p>In this Terms of Use, unless expressly provided otherwise, the following expressions have the following meanings:</p>
    <ul>
      <li><strong>You</strong> means the party registered as a SAKU Application user to use the Services provided in the SAKU Application.</li>
      <li><strong>Affiliate</strong> means, in relation to a party, any entity that controls, is under the control of, or is under common control with or the legal power to direct or cause the direction of the general management and policies of that party.</li>
      <li><strong>SAKUBiz Application</strong> is a mobile app with the name SAKUBiz for Loyalty Memberships, and its derivative which can be downloaded via playstore for Android users as well as through via app store for iOS users that We develop to support Our Services provided.</li>
      <li><strong>Personal Information</strong> means information regarding Yourself which can be privately identified and collected through the SAKUBiz Application, such as name, address, date of birth and occupation (if You are a person), corporate data and identity document (if You are not a person), phone number, email address and other information which may identify You as an user of SAKUBiz Application.</li>
      <li><strong>We/Our/Us</strong> means SAKUBiz (including affiliate) a company established under the laws of the states and federal of Malaysia.</li>
      <li><strong>Terms of Use</strong> means terms and condition or standard operational procedures or other terms in connection with SAKUBiz Application or website developed by Us.</li>
      <li><strong>Service</strong> means various services offered by SAKUBiz Application or website.</li>
      <li><strong>Force Majeure</strong> means any cause which is not reasonably within the control of the person affected including, without limitation, an act of God, an industrial dispute, war, blockade, disturbance, lightning, fire, earthquake, storm, flood, explosion or meteor, restraint of a statutory authority, expropriation, prohibition, unavailability or delay in availability of equipment or transport.</li>
      <li><strong>Customer Service</strong> is the customer service center We provide for You and can be reached by email <a href="mailto:saku@binfinite.com.my">saku@binfinite.com.my</a> and can be used when You have problems in the use of SAKUBiz Application or when you use Our Service.</li>
      <li><strong>Website</strong> means Our website at <a href="https://saku.my">https://saku.my</a> or other sites which We developed officially to support the Service ecosystem.</li>
    </ul>

    <h2>2. TERMS FOR USING THE APPLICATION</h2>
    <p>In this Terms of Use, unless expressly provided otherwise, the following expressions have the following meanings:</p>
    <ul>
      <li>You represent and warrant that You are an individual legally entitled to enter into a binding agreement under the laws of the states and federal of Malaysia, in particular the Terms of Use, to use the SAKU Application. Otherwise, We will be entitled by law to cancel any agreement entered into with You. You further represent and warrant that You have the right, authority and capacity to use the Service and to abide by the Terms of Use.</li>
      <li>We collect and process your Personal Information, such as Your name, address, date of birth, and occupation (if You are a person), corporate identity documents (if You are not a person), mobile number, email address and other information who may be able to identify You as an User of SAKU Application. You must provide accurate and complete information, keep the information up to date and agree to provide Us whatever proof of identity We may reasonably ask for.</li>
      <li>You can only use the SAKU Application once You have signed up with it. Upon successfully signing up, the SAKU Application will provide You with a personal account that can be accessed with a mobile phone number.</li>
      <li>Only You may use Your own account and You undertake not to authorize others to use Your identity or account. You may not assign or otherwise transfer Your account to any other parties. You must keep the security and confidentiality of Your account and any identification We provide to You.</li>
      <li>You undertake that You will use the Application only for its intended use to obtain the Service. You may not abuse or use the SAKU Application for fraudulent purposes or to cause any inconvenience to others.</li>
      <li>You understand and agree that Your use of the SAKU Application will also be subject to Our Privacy Policy as may be amended from time to time. By using the SAKU Application, You also give Your consent as required under our Privacy Policy.</li>
      <li>Please note that You are responsible for the use of Your account and may be held liable even if it is abused by another person.</li>
      <li>You understand and agree by downloading, installing, and/or using the SAKU Application, you are allowing the use of your phone number that is registered in SAKU Application (both phone number that you registered at first and the phone number that We got from other parties who had collaborated with Us) as Our communication method in accordance with the Privacy Policy that we have set before.</li>
    </ul>

    <h2>3. THE MATTERS RELATING TO PERSONAL INFORMATION</h2>
    <p>
      You hereby agree that We may collect, store, process, disclose information access, review and/or use personal information
      about you. We ensure that all personal information submitted by you through the SAKU Application and/or our website is well
      protected and encrypted. We agree to keep all personal information private and not to use such personal information for any
      purpose other than for matters related to our Services. However, this does not apply to:
    </p>
    <ul>
      <li>Prevention of fraudulent acts and/or matters relating to anti money laundering and criminal acts of terrorism;</li>
      <li>Personal information that is generally known to the public; and</li>
      <li>Such personal information is required to be disclosed by law, government or authorized institution under existing regulations.</li>
    </ul>

    <h2>4. THE MATTERS RELATING TO PERSONAL INFORMATION</h2>
    <p>
      You may only access the Service using authorized means. It is Your responsibility to check and ensure that You have
      downloaded the correct SAKU Application for Your device. We are not liable if You do not have a compatible device or if
      You have downloaded the wrong version of the SAKU Application to Your device.
    </p>
    <p>
      We reserve the rights not to permit You to use the Service should You use the SAKU Application with an incompatible or
      unauthorized device or for purpose other than which the SAKU Application is intended to be used.
    </p>
    <p>We do not represent or warrant that:</p>
    <ul>
      <li>The use of the Services and/or SAKU Application will be secured, timely, uninterrupted or error-free or operate in combination with any other hardware, software, system or data;</li>
      <li>Any stored data will be accurate or reliable;</li>
      <li>The services will meet Your requirements or expectations;</li>
      <li>The SAKU Application or the server(s) that make the Service are free of viruses or other harmful components.</li>
    </ul>
    <p>By using the SAKU Application, You agree that:</p>
    <ul>
      <li>You will only use the Service for lawful purposes;</li>
      <li>You will only use the Service for the purpose for which it is intended to be used;</li>
      <li>You will not use the SAKU Application for fraudulent purposes;</li>
      <li>You will not use the Service and SAKU Application for purposes other than obtaining the Service;</li>
      <li>You will not try to harm the Service and SAKU Application in any way whatsoever;</li>
      <li>You will only use the SAKU Application for Your own use;</li>
      <li>You will keep secure and confidential Your account password or any identification We provide You which allows access to the Service;</li>
      <li>You will provide the Company with proof of identity as it may reasonably request or require;</li>
      <li>You agree to provide accurate, current and complete information as required for the Service and undertake the responsibility to maintain and update Your information in a timely manner to keep it accurate, current and complete at all times during the Terms of Use. You agree that We may rely on Your information as accurate, current and complete. You acknowledge that if Your information is untrue, inaccurate, not current or incomplete in any respect, We have the right but not the obligation to terminate this Terms of Use and Your use of the Service at any time with or without notice;</li>
      <li>You will only use an access point or data account which You are authorized to use;</li>
      <li>You agree that the Service is provided on a reasonable effort basis; and</li>
      <li>You agree that Your use of the Service will be subject to the Our Privacy Policy as may be amended from time to time.</li>
    </ul>

    <h2>5. OUR LIABILITIES</h2>
    <p>
      We employ appropriate and reasonable technical and security measures to keep SAKU Application secure and free from virus
      and error. However, as effective as this technology is, no security system is impenetrable. We therefore cannot guarantee
      the security of Our database nor can We guarantee that the information You provide will not be intercepted while being
      transmitted to Us.
    </p>
    <p>
      The SAKU Application may be subject to limitations, delays, and other problems inherent in the use of the internet and
      electronic communications including the device used by You being faulty, not connected, out of range, switched off or not
      functioning. We are not responsible for any delays, delivery failures, damages or losses resulting from such problems.
    </p>
    <p>Any problems arising from the use of SAKU Application and/or Our website may be reported to Us through the available Customer Service.</p>

    <h2>6. INTELLECTUAL PROPERTY MATTERS</h2>
    <p>
      SAKU, including its name and logo, SAKU Application and the Service, is protected by copyright, trademark and other rights
      provided under the laws of the states and federal of Malaysia. We exclusively own all rights, title and interest in and to
      the SAKU Application, including all associated intellectual property rights.
    </p>
    <p>
      Without derogating from Our rights under any applicable law or these Terms of Use, You are advised that any attempted or
      actual infringement of this provision will result in the termination of all Your rights under these Terms of Use. If You
      circumvent any of the means taken by Us to protect the Service from unauthorized use, You must immediately cease any and
      all use of the Service, and You undertake to do so.
    </p>

    <h2>7. TERMINATION</h2>
    <p>
      We reserve the right to immediately suspend, restrict or terminate these Terms of Use and Your use of the SAKU Application
      if We have reasonable grounds to suspect that You have breached or violated any provision of these Terms of Use or the
      prevailing laws and regulations.
    </p>

    <!-- NEW SECTION (d): Assignment & Novation -->
    <h2>8. ASSIGNMENT &amp; NOVATION</h2>
    <p>
      In the event of a sale, merger, acquisition, restructuring, or other transfer of ownership or control of the
      <strong>SAKU Application</strong> or its associated business operations, SAKU may assign or novate its rights and
      obligations under these Terms of Use to the acquiring or successor entity. By continuing to use the SAKU Application
      following notification of such change, You are deemed to have consented to the novation of these Terms of Use and agree
      to be bound by the terms and conditions as may be adopted or amended by the new entity.
    </p>

    <!-- NEW SECTION (e): Transfer of Personal Data on Sale -->
    <h2>9. TRANSFER OF PERSONAL DATA ON SALE</h2>
    <p>
      In the event of a sale, merger, acquisition, restructuring, or other transfer of ownership or control of the
      <strong>SAKU Application</strong> or its associated business operations, SAKU reserves the right to transfer all user data,
      account information, content, and related records to the new owner or successor entity. Any such transfer shall be
      conducted in accordance with applicable data protection laws and shall be subject to the same level of privacy protection
      as described in these Terms of Use and the Privacy Policy. By continuing to use the SAKU Application following notification
      of such change, You consent to the transfer of Your data as part of the transaction.
    </p>

    <h2>10. MISCELLANEOUS</h2>
    <p>
      Our waiver or forbearance of failure to claim a breach of any provision of these Terms of Use or to exercise any right
      provided by these Terms of Use or the applicable law, may not be deemed to constitute a waiver with respect to any
      subsequent breach of any provision hereof.
    </p>
    <p>These Terms of Use are drawn up, which versions will be binding on You and Us.</p>
    <p>You may not transfer or assign Your rights under these Terms of Use, without our prior written approval.</p>
    <p>
      If any terms under these Terms of Use is held to be illegal, invalid or unenforceable, in whole or in part, under any
      enactment or rule of law, the term or part of it will, to that extent, be deemed not to form part of these Terms of Use
      but the legality, validity or enforceability of the remainder of these Terms of Use will not be affected.
    </p>
    <p>
      These Terms of Use are governed by and to be construed under the laws of any jurisdiction where the SAKU Application is
      used. Any disputes arising from the Terms of Use shall be resolved by Arbitration under Malaysia’s arbitration rules –
      Asian International Arbitration Center (AIAC).
    </p>
  </main>
</div>
`;

  return (
    <div
      dangerouslySetInnerHTML={{
        __html: userTermsEN,
      }}
    />
  );
};

export default UserTerms;
